import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MediationEngine} from 'src/globalTypes';
import {I18NextPipe} from 'angular-i18next';
import {NgForOf, NgIf, NgOptimizedImage} from '@angular/common';
import {SharedModule} from 'app/shared/shared.module';
import {trackByIndex} from 'app/core/helpers/trackby';

@Component({
    selector: 'mediations-icons',
    standalone: true,
    imports: [NgForOf, SharedModule, NgOptimizedImage, NgIf],
    templateUrl: './mediations-icons.component.html',
    styleUrl: './mediations-icons.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediationsIconsComponent {
    @Input() mediations: MediationEngine[];
    protected readonly MediationEngine = MediationEngine;

    constructor(private i18next: I18NextPipe) {}

    labelMediationEngine(label: MediationEngine): string {
        return this.i18next.transform('apps.appsList.mediationEngine.' + label);
    }
    buildIconMediationEngine(name: MediationEngine): string {
        switch (name) {
            case MediationEngine.APPODEAL:
                return 'appodeal-new-logo';
            case MediationEngine.APPLOVIN_MAX:
                return 'applovin';
            case MediationEngine.BIDON:
                return '/assets/images/icons/bidon.png';
            case MediationEngine.LEVEL_PLAY:
                return 'unity';
        }
    }

    trackByIndex = trackByIndex;
}
